import React, {useContext, useState} from "react";
import '../../../assets/stylesheets/modal.css'
import CommonModal from "./CommonModal";
import { csrfToken } from "../../utis/csrfTokenUtils";
import { categories } from "../../hooks/utils";
import {networkService} from "../config/axios";
import UserInfoContext from "../../utis/userInfoContext";
const SupportModal = ({ setOpenSupport, openSupport }) => {
    const { setShowNotifications } = useContext(UserInfoContext)

    const SupportModalBody = () => {
        const [feedback, setFeedback] = useState({
            category: 0,
            did_text: "",
            expected_text: "",
            happened_text: ""
        })

        const handleFieldsChange = (e) => {
            const { name, value } = e.target;
            setFeedback({
                ...feedback,
                [name]: value,
            });
        };

        const handeSendFeedback = async () => {
            const data = {
                authenticity_token: csrfToken(),
                feedback: {
                    ...feedback,
                    url: window.location.href,
                }
            }
            await networkService(`feedbacks.json`, 'POST', data).
                then((response) => {
                    if (response.status === 201) {
                        setOpenSupport(false);
                        setShowNotifications({
                            showToast: true,
                            toastType: "success",
                            toastMessage: `Support ticket added successfully`,
                        });
                    }
                }).
                catch((error) => {
                    console.log(error)
                });
        }

        const categoriesArray = Object.entries(categories).map(([key, name]) => ({
            value: Number(key),
            name,
        }));

        return (
            <form className="support-modal-form">
                <div className="support-form-group">
                    <label className="support-form-label">*Reason</label>
                    <select
                        className="support-form-select"
                        name="category"
                        value={feedback.category}
                        onChange={handleFieldsChange}
                    >
                        <option value="reason">Select a reason</option>
                        {
                            categoriesArray?.map((elem) => {
                                return (
                                    <option key={elem?.value} value={elem?.value}>{elem?.name}</option>
                                )
                            })
                        }
                    </select>
                </div>

                <div className="support-form-group">
                    <label className="support-form-label">*What I did</label>
                    <textarea
                        className="support-form-textarea"
                        name='did_text'
                        value={feedback.did_text}
                        onChange={(e) => handleFieldsChange(e)}
                        placeholder="Describe what action you took..."
                    />
                </div>

                <div className="support-form-group">
                    <label className="support-form-label">*What I expected</label>
                    <textarea
                        className="support-form-textarea"
                        name='expected_text'
                        value={feedback.expected_text}
                        onChange={(e) => handleFieldsChange(e)}
                        placeholder="Describe what you expected to happen..."
                    />
                </div>

                <div className="support-form-group">
                    <label className="support-form-label">*What happened</label>
                    <textarea
                        className="support-form-textarea"
                        name='happened_text'
                        value={feedback.happened_text}
                        onChange={(e) => handleFieldsChange(e)}
                        placeholder="Describe what actually happened..."
                    />
                </div>

                <div className="support-form-note">
                    <p>*Note: Please include links to screen shots or video using <a href="https://monosnap.com" target="_blank" rel="noopener noreferrer">Monosnap</a> or <a href="https://loom.com" target="_blank" rel="noopener noreferrer">Loom</a>.</p>
                </div>

                <div className="support-form-actions">
                    <button
                        type="button"
                        className="support-form-btn"
                        onClick={() => handeSendFeedback()}
                    >
                        Send Feedback
                    </button>
                </div>
            </form>
        )
    }

    return (
        <CommonModal
            title={'Send Feedback'}
            modalStatus={openSupport}
            changeActiveStatus={setOpenSupport}
            classList="header-profile-modal-wrapper"
            centered
        >
            <SupportModalBody />
        </CommonModal>
    )
}

export default SupportModal;